import { ItemAbstract } from './item';

export class ItemCsv implements ItemAbstract {
    patternName: string;
    name: string;
    slug: string;
    categories: string[];
    imageUrl: string;
    parameters: {
        atrapa: boolean;
        grupa: string;
        width: string;
        height: string;
        width_z_kam: number;
        height_z_kam: number;
        price: number;
        price_z_kam: number;
        stone_label: string;
    };

    constructor(dto: string[]) {
        this.patternName = dto[1];
        this.name = dto[1];
        this.slug = `csv:${dto[1].toLowerCase().trim().toString()}`;
        this.categories = [dto[0]];
        this.imageUrl = dto[5];
        this.parameters = {
            atrapa: null,
            grupa: null,
            width: dto[2].trim().replace('mm', ''),
            height: dto[3].trim().replace('mm', ''),
            width_z_kam: null,
            height_z_kam: null,
            price: null,
            price_z_kam: null,
            stone_label: null,
        };
    }
}
